/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {JobStatus} from '@ion/core/src/types/entities';
import {formatDateTime} from '@ion/core/src/utils/DateUtil';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';

export interface JobInfoPanelType {
  jobStatus: JobStatus;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  gridContainer : {
    width : '100%'
  },
  headerItem : {
    ...dlsAlt('typography', 'label3'),
    lineHeight : '24px',
    fontWeight : 500,
    fontSize   : '14px',
    color      : dlsColor('grey1'),
    padding    : '5px 20px'
  },
  bodyItem : {
    ...dlsAlt('typography', 'label2'),
    color   : dlsColor('grey1'),
    padding : '5px 20px 15px'
  },
  taskItem : {
    ...dlsAlt('typography', 'label2'),
    fontSize : '30px',
    color    : dlsColor('grey1'),
    padding  : '5px 20px 15px'
  },
  nameItem : {
    fontSize                       : '16px',
    [theme.breakpoints.down('sm')] : {
      ...dlsAlt('typography', 'cta2')
    }
  }
}));

/**
 * Info Panel component that displays the job Status data for the selected item.
 */
export const JobInfoPanel = ({
  jobStatus
}: JobInfoPanelType) => {
  const classes = useStyles();

  return (
    <Grid container
      spacing={0}
      alignItems='flex-start'
      justifyContent='flex-start'
      className={classes.gridContainer}>
      <Grid item md={4}>
        <div className={classes.headerItem}>
          {translate('jobstatus:grid.columns.status')}
        </div>
        <div className={classes.bodyItem}>
          {jobStatus?.status}
        </div>
      </Grid>
      <Grid item md={4}>
        <div className={classes.headerItem}>
          {translate('jobstatus:grid.columns.createdBy')}
        </div>
        <div className={classes.bodyItem}>
          {jobStatus?.username}
        </div>
      </Grid>
      <Grid item md={4}>
        <div className={classes.headerItem}>
          {translate('jobstatus:grid.columns.createdon')}
        </div>
        <div className={classes.bodyItem}>
          {formatDateTime(jobStatus?.createdAt)}
        </div>
      </Grid>
    </Grid>
  );
};

export default JobInfoPanel;
